import { isTalkie } from '../utils/env';
import { TalkieTrack } from './talkie';
import { Track } from './xingye';

const TrackInstance = isTalkie ? new TalkieTrack() : new Track();
export { TrackInstance as track };
export const TrackGlobalParams: Record<string, string | number> = {};
export * from './util';
